import { linkMedicalDetailsPayload } from './link-medical-details-payload';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs';
import { FeedbackService } from 'src/app/core/services/feedback.service';
import { PatientService } from 'src/app/core/services/patient.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from 'src/app/core/components/base/base.component';
import { FormUtils } from 'src/app/core/utils/form.utils';
import { SchemeReferenceService } from 'src/app/core/scheme-reference/scheme-reference.service';
import { MedicalAidPick } from 'src/app/core/scheme-reference/scheme-pick';
import { schemeCodeOf } from 'src/app/core/utils/scheme-code';
import { MedicalAidPickerInitial } from 'src/app/shared/components/medical-aid-picker/medical-aid-picker.component';

@Component({
  selector: 'app-link-patient-medical-details-dialog',
  templateUrl: './link-patient-medical-details-dialog.component.html',
  styleUrls: ['./link-patient-medical-details-dialog.component.scss']
})
export class LinkPatientMedicalDetailsDialogComponent extends BaseComponent implements OnInit {

  form!: FormGroup;
  patient: any;
  /** Scheme, plan and option from Connect's scheme reference, or typed when the medical aid is not listed. */
  pick: MedicalAidPick | null = null;
  medicalAidInitial: MedicalAidPickerInitial | null = null;

  _forceDetails: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { forceDetails?: boolean },
    private fb: FormBuilder,
    private patientService: PatientService,
    public schemeReference: SchemeReferenceService,
    public dialogRef: MatDialogRef<LinkPatientMedicalDetailsDialogComponent>,
    fs: FeedbackService,
    md: MatDialog
  ) {
    super(fs, md);
    this._forceDetails = this.data?.forceDetails || false;
    this.initializeForm();
  }

  ngOnInit(): void {
    this.patientService.currentPatient$
      .pipe(takeUntil(this.destroy$))
      .subscribe((patient: any) => {
        this.patient = patient;
        this.form.patchValue(this.patient);
        this.medicalAidInitial = {
          schemeCode: schemeCodeOf(patient?.medicalSchemeCode),
          planCode: schemeCodeOf(patient?.medicalPlanCode),
          optionCode: schemeCodeOf(patient?.medicalPlanOptionCode),
        };
      });
  }

  initializeForm(): void {
    this.form = this.fb.group({
      medicalMainMember: ['', Validators.required],
      medicalAidNumber: ['', Validators.required],
      medicalDependantCode: ['', Validators.required],
      gapCover: [''],
      gapCoverNumber: [''],
    })

    FormUtils.showAllFormErrorStates(this.form);
  }

  linkPatientMedicalAid(): void {
    // A patient already linked may save just the member details; the picker reports only a change.
    const alreadyLinked = !!this.medicalAidInitial?.schemeCode;
    if ((!this.pick && !alreadyLinked) || !this.form.valid) {
      this.showToastMessage('Please select valid medical aid/insurance details for this patient');
      return;
    }

    const sub = this.patientService.updatePatient(this.patient.id, linkMedicalDetailsPayload(this.form.value, this.pick))
      .subscribe(() => {
        this.showToastMessage(!this.pick || 'scheme' in this.pick
          ? 'Patient medical aid/insurance details updated succesfully'
          : 'Saved as typed. This medical aid is not linked to the scheme list, so claims for it cannot be switched.');
        this.dialogRef.close(true);
        sub.unsubscribe();
      });
  }
}
